import { Component } from "react";
import SerieArea from "../Components/Series/SerieArea";

class Series extends Component {
    render() {
        return (
            <div>
                <SerieArea />
            </div>
        )
    }
}

export default Series;

/** 
import './Movies.css';
import axios from 'axios';
import {useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Card} from 'react-bootstrap';

function Series() {
    const [serie, setSerie] = useState("");
    const [result, setResult] = useState([]);
    const [apiKey, setApiKey] = useState("aed346e7e561872b9429ec2a49a62170");

    function handleChange(event) {
        const serie = event.target.value;

        setSerie(serie);
    }

    function handleSubmit(event) {
        event.preventDefault();

        axios.get(`https://api.themoviedb.org/3/search/tv?api_key=${apiKey}&language=en-US&page=1&include_adult=false&query=${serie}`)
        .then(data => {
            setResult(data.data.results)
        })
    }

    return (
        <div class="container">
        <form onSubmit={handleSubmit}>
           <div className="form-group" style={{display: 'inline-block', marginLeft: '900px'}}>
               <input type="text" style={{width: '300px'}} onChange={handleChange} className="form-control" placeholder="Search serie"/>
           </div>
           <button type="submit" className="btn btn-warning" style={{margin: '5px', height: '25px'}}>Search</button>
       </form>
       {result.map(serie => (
           <div key={serie.index} className="searchResult" style={{display: 'inline-block'}}>
           <Card style={{ width: '14rem', height:'20rem', marginBottom: '50px', margin: '20px', left: '15px'}}>
           <Card.Img variant="top" src={"https://image.tmdb.org/t/p/w500" + serie.poster_path} />
           <Card.Body>
               <Card.Title>{serie.name}</Card.Title>
           </Card.Body>
           </Card></div>
       ))}
        </div>
    );
}

export default Series;
*/